<template>
  <div>
    <div class="row">
      <div :class="$LEFT_COL">
        <h1 class="h4 text-center">Accelerated Mobile Pages</h1>
        <p class="lead mb-4 text-center">Let's get you quickly up and running!</p>

        <AMPBasic noAdvance parentId="setup-amp-collapse-group" />
      </div>
      <div :class="$RIGHT_COL" ref="positionRef"></div>
      <iPhone dummy :positionRef="positionRef" v-if="positionRef" />
    </div>
    <SaveButton :hasChanged="true" @revert="skip" @click="next" saveText="Continue" bar :discard="hasChanged" discardText="Skip & customize later" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import CollapseItem from '@/components/CollapseItem'
import AMPBasic from '@/components/setup/AMPBasic'
import iPhone from '@/components/iPhone'

import iphone from '@/mixins/iphone'
import watchForChange from '@/mixins/watchForChange'

export default {
  components: {
    iPhone,
    CollapseItem,
    AMPBasic
  },
  mixins: [
    iphone,
    watchForChange()
  ],
  created: async function () {
    this.canSave = true
  },
  methods: {
    ...mapActions([ 'saveMaster' ]),
    next: async function () {
      if (!this.canSave) return
      this.canSave = false

      await this.saveMaster()
      this.move()
    },
    skip: async function () {
      if (!this.canSave) return
      this.canSave = false

      this.move()
    },
    move: async function () {
      await this.$nextTick()

      this.$store.commit('NEXT_STEP')

      this.$router.replace({ name: 'setup_plan' })
    }
  }
}
</script>
